import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { verifyAdditonalEmail } from '../../../../../redux/actions/userActions';
import urls from '../../../../../routing/urls';

const VerifyEmail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const email = searchParams.get('email');
  const userId = searchParams.get('user');

  useEffect(() => {
    dispatch(verifyAdditonalEmail(email, userId));
    navigate(urls.settings);
  }, [email, userId]);

  return null;
};

export default VerifyEmail;
